import React from "react";
import { Button } from "./ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "./ui/card";
import { RefreshCw } from "lucide-react";

const PostMeetingScreen: React.FC = () => {
    const handleRejoin = () => {
        window.location.reload();
    };

    return (
        <div className="min-h-screen bg-background flex items-center justify-center p-4">
            <Card className="w-full max-w-md bg-card border-border shadow-xl">
                <CardHeader className="text-center space-y-2">
                    <CardTitle className="text-2xl font-bold text-foreground">
                        You left the meeting
                    </CardTitle>
                </CardHeader>
                <CardContent className="space-y-6">
                    <p className="text-center text-muted-foreground">
                        You have disconnected from the session.
                    </p>

                    <Button
                        onClick={handleRejoin}
                        className="w-full"
                        size="lg"
                    >
                        <RefreshCw className="mr-2 h-4 w-4" />
                        Rejoin Meeting
                    </Button>
                </CardContent>
            </Card>
        </div>
    );
};

export default PostMeetingScreen;
